<template>
  <div class="modal-wrap">
    <div class="modal-header">
      <p class="mb-15 bold">Välj stoppdatum</p>
    </div>
    <div class="modal-content">
      <div class="grid2col">
        <div>
          <input type="date" v-model="date">
        </div>
        <div>
          <input type="time" v-model="time" class="width-100" min="00:00" max="23:59">
        </div>
      </div>

      <div class="flex align-middle mt-30">
        <label class="switch mr-10">
          <input type="checkbox" class="mr-5" v-model="dontNotifyOnNewBids">
          <div class="slider round"></div>
        </label>
        <span class="pl-15">Sluta meddela budgivaren vid nya bud</span>
      </div>
    </div>

    <div class="modal-buttons">
      <div class="grid2col">
        <button class="width-100 fg-black" @click="abort">
          avbryt
        </button>
        <button class="width-100" @click="save">
          spara
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'stopBid',
  data() {
    return {
      date: new Date().toISOString().slice(0, 10),
      time: new Date().toLocaleTimeString().slice(0, 5),
      dontNotifyOnNewBids: false
    }
  },
  computed: {
    bidData() {
      return this.$store.state.currentUser;
    }
  },
  methods: {
    // As a precaution clear the userdata so no risk for accidently updating wrong user
    clearUserData() {
      this.$store.commit('STORE_CURRENT_USER_DATA', {});
    },
    abort() {
      this.clearUserData();
      this.$root.modalOpen = false;
    },
    save() {
      let notifyThesePeople = this.$store.getters.notifyThesePeople;

      let postData = {
        bidIdentity: this.bidData.bidIdentity,
        objectId: this.bidData.objectId,
        date: this.date +' '+ this.time+':00',// todo: hmm check if the space still needed ? it's wierd.
        notifyOnNewBids: this.dontNotifyOnNewBids ? 0 : 1
      };

      this.$root.callFasAdApi("/internalapi/bid/stop-bid-identity/", "POST", postData)
      .then((data) => {
        this.clearUserData();
        // refresh store
        this.$store.dispatch('storeCurrentSelectedListing', { listingId: this.$route.params.id });
        this.$store.dispatch('storeBidReceivers', { id: this.$route.params.id });
        this.$root.handleResponseMessage(data, "Budgivaren stannad!");
      })
      .catch(console.error);

      this.$root.modalOpen = false;

      // set default sms and set receivers chosen from boxes
      this.$store.commit('STORE_SMS_MAIL_DELIVERYWAY', 'sms');
      this.$store.commit('STORE_SMS_MAIL_RECIEVERS', notifyThesePeople);

      // message template
      this.$root.callFasAdApi("/internalapi/message-template/get-bid-stop/objectId/" + this.$route.params.id)
      .then((data) => {
        if (data.status === 200) {
          let dataContent = '';
          const bidIdentity = this.bidData.bidIdentity;
          this.$store.getters.getCurrentActiveListing.bidIdentities.forEach((bidder) => {
            if (bidder.id === bidIdentity) {
              dataContent = data.data.content.replace('{special_budgivare_id}', bidder.bidder)
            }
          });

          this.$store.commit('STORE_SMS_MAIL_SUBJECT', data.data.subject);
          if (dataContent) {
            this.$store.commit('STORE_SMS_MAIL_CONTENT', dataContent);
          } else {
            this.$store.commit('STORE_SMS_MAIL_CONTENT', data.data.content);
          }

          this.$store.commit('STORE_SMS_MAIL_CHOSEN_MESSAGING_TEMPLATE', data.data.id);
        }
      })
      .catch(console.error);

      setTimeout(() => {
        this.$emit('submitted', { component: "sendSmsOrMail" });
      }, 1200);
    }
  }
}
</script>